import { QuestionBase } from './base.question.class'

export class LabelOnlyQuestion extends QuestionBase<string> {
  controlType = 'label'

  getValidators() {
    return []
  }

  // no value required
  saveValueToData() {}
  valueFromData() {}
}
